import { get, post, put, del, exportExcel } from "./http";
import { BaseUrlNew } from "./NewSiteUrl";
import { headerDemo } from "./editHeader";

// ++++++++++ 甄惠装动态 & 财富学院 ++++++++++

// 新增甄惠装动态
export const postNews = params =>post( BaseUrlNew + "/api/news",params, headerDemo, 1, '4.0');
// 编辑甄惠装动态
export const putNews = params =>put( BaseUrlNew + "/api/news",params, headerDemo, 1, '4.0');
// 新增财富学院
export const postFortuneCollege = params =>post( BaseUrlNew + "/api/fortuneCollege",params, headerDemo, 1, '4.0');
// 修改财富学院
export const putFortuneCollege = params =>put( BaseUrlNew + "/api/fortuneCollege",params, headerDemo, 1, '4.0');


// ++++++++++ 装修必看 ++++++++++

// 查询装修必看列表
export const getGuessYouLike = params =>get( BaseUrlNew + "/api/guess-you-like",params, 1, '3.0');
// 排序
export const putGuessYouLike = params =>put( BaseUrlNew + "/api/guess-you-like",params, headerDemo, 1, '3.0');
// 根据关键字搜索装修必看内容配置
export const getKeyword = params =>get( BaseUrlNew + "/api/guess-you-like/keyword",params, 1, '3.0');
// 添加装修必看内容配置
export const postGuessYouLike = params =>post( BaseUrlNew + "/api/guess-you-like",params, headerDemo, 1, '3.0');
// 删除装修必看配置内容
export const deleteGuessYouLike = params =>del( BaseUrlNew + "/api/guess-you-like",params, 1, '3.0');


// ++++++++++ 搜索推荐 ++++++++++

// 搜索推荐列表
export const getHotSearch = params => get(BaseUrlNew + '/api/hotSearch', params, 1, '4.0');
// 新增搜索推荐
export const postHotSearch = params =>post( BaseUrlNew + "/api/hotSearch",params, headerDemo, 1, '4.0');
// 查看、编辑回显搜索推荐（详情）
export const getHotSearchDetails = params => get(BaseUrlNew + '/api/hotSearch/details', params, 1, '4.0');
// 编辑搜索推荐
export const putHotSearch = params =>put( BaseUrlNew + "/api/hotSearch",params, headerDemo, 1, '4.0');
// 删除搜索推荐
export const deleteHotSearch = params =>del( BaseUrlNew + "/api/hotSearch",params, 1, '4.0');


// ++++++++++ 评论 ++++++++++

// 店铺评论列表
export const getProductReviewsList = params => get(BaseUrlNew + '/api/ProductReviews', params, 1, '4.0');
// 回复评论
export const postProductReviewsReply = params => post( BaseUrlNew + "/api/ProductReviews/reply",params, headerDemo, 1, '4.0');
// 删除橱窗商品评论
export const deleteProductReviews = (params, newId) =>del( BaseUrlNew + "/api/ProductReviews?id=" + newId, params, 1, '4.0');
// 新增评论
export const postProductReviewsAdd = params => post( BaseUrlNew + "/api/ProductReviews/add",params, headerDemo, 1, '4.0');
// 查看评论
export const getProductReviewsSee = params => get(BaseUrlNew + '/api/ProductReviews/see', params, 1, '4.0');
// 获取评论标签
export const getProductReviewsLabel = params => get(BaseUrlNew + '/api/ProductReviews/label', params, 1, '4.0');
// 获取品牌店铺有效商品
export const getEffectiveWG = params => get(BaseUrlNew + '/api/brandBusiness/effectiveWG', params, 1, '4.0');
// 获取发布用户
export const getArticleVideoJzUser = params => get( BaseUrlNew + "/api/activityVideo/articleVideoJzUser",params, 1, '3.0');


// 【后台】获取评论列表
export const backgetlist = params => get( BaseUrlNew + "/api/comment/back/getlist",params, 1, '1.0');
// 【后台】获取评论详情
export const backgetinfo = params => get( BaseUrlNew + "/api/comment/back/getinfo",params, 1, '1.0');
// 【通用】删除
export const commentdel = params => post( BaseUrlNew + "/api/comment/del",params, headerDemo, 1, '1.0');
// 【通用】添加评论/回复
export const commentadd = params => post( BaseUrlNew + "/api/comment/add",params, headerDemo, 1, '1.0');
// 【通用】获取评论标签集合
export const labelgetlist = params => get( BaseUrlNew + "/api/comment/label/getlist",params, 1, '1.0');



// ++++++++++ 询价管理 ++++++++++

// 询价列表
export const getBackList = params => get(BaseUrlNew + '/api/newInquiry/back/list', params, 1, '1.0');
// 询价单详情
export const getBackDetails = params => get(BaseUrlNew + '/api/newInquiry/back/details', params, 1, '1.0');
// 获取竞标品牌（类型）
export const getBackQuoteType = params => get(BaseUrlNew + '/api/newInquiry/back/quoteType', params, 1, '1.0');
// 报价
export const postBack = params => post( BaseUrlNew + "/api/newInquiry/back",params, headerDemo, 1, '1.0');


// ++++++++++ 店铺订单 ++++++++++

// 导出店铺订单列表
export const postShopOrderExportToExcel = params => post("/VIP/VIPTradeRecordManagement/ShopOrderExportToExcel", params);
// 订单发货
export const putDeliver = params =>put( BaseUrlNew + "/api/brandBusiness/deliver",params, headerDemo, 1);
// 审核退款
export const putReviewRefund = params =>put( BaseUrlNew + "/api/weChatServerPay/reviewRefund",params, headerDemo, 1);

// ++++++++++ 提现模块 ++++++++++

// 提现审核列表
export const postTransferAccountsVerifyList = params => post(BaseUrlNew + '/web/transferAccounts/transfer-accounts/getTransferAccountsVerifyList', params, headerDemo, 1);
// 批量审核
export const postTransferAccountsVerify = params => post(BaseUrlNew + '/web/transferAccounts/transfer-accounts/transferAccountsVerify', params, headerDemo, 1);
// 后台店铺审核展示订单列表
export const getTransferOrderNumsInfo = params => post(BaseUrlNew + '/web/transferAccounts/transfer-accounts/getTransferOrderNumsInfo', params, headerDemo, 1);
// 提现打款管理列表
export const postTransferAccountsPaymentList = params => post(BaseUrlNew + '/web/transferAccounts/transfer-accounts/getTransferAccountsPaymentList', params, headerDemo, 1);
// 导出待打款
export const getExcelTransferAccountsPaymentList = params =>exportExcel( BaseUrlNew + "/web/transferAccounts/transfer-accounts//get/excel/getTransferAccountsPaymentList", params, headerDemo, 1);
// 导出提示
export const getTransferAccountsPaymentListInfo = params =>post( BaseUrlNew + "/web/transferAccounts/transfer-accounts//get/excel/getTransferAccountsPaymentListInfo", params, headerDemo, 1);
// 导入打款结果
export const postUpload = params =>post( BaseUrlNew + "/web/transferAccounts/transfer-accounts/upload", params, headerDemo, 1);

// ++++++++++ 平台-活动佣金配置 ++++++++++

// 获取未配置活动佣金活动类型
export const GetNoCommissionSettingActivityForm = params => post('/ActivityService/ActivityCommissionSetting/GetNoCommissionSettingActivityForm', params);
// 查看活动佣金配置列表
export const GetActivityCommissionSettingList = params => post('/ActivityService/ActivityCommissionSetting/GetActivityCommissionSettingList', params);
// 查看活动佣金配置详情
export const GetActivityCommissionSettingById = params => post('/ActivityService/ActivityCommissionSetting/GetActivityCommissionSettingById', params);
// 修改活动佣金配置开启关闭状态
export const EnableCommissionSetting = params => post('/ActivityService/ActivityCommissionSetting/EnableCommissionSetting', params);
// 修改活动佣金配置
export const UpdateCommissionSetting = params => post('/ActivityService/ActivityCommissionSetting/UpdateCommissionSetting', params);
// 新增活动佣金配置
export const InsertCommissionSetting = params => post('/ActivityService/ActivityCommissionSetting/InsertCommissionSetting', params);
// 获取配置佣金城市列表
export const GetCurrentUserCityList = params => post('/ActivityService/ActivityCommissionSetting/GetCurrentUserCityList', params);
// 获取一、二级品类树
export const GetBrandTypeAndNodeTree = params => get('/BaseDataNew/BrandType/GetBrandTypeAndNodeTree', params);


// ++++++++++ 分享审核 & 分享申诉 ++++++++++

// 获取用户任务审核列表
export const postauditlist = params => post( BaseUrlNew + "/api/task/auditlist",params, headerDemo, 1, '1.0');
// 获取用户任务申诉列表
export const postappeallist = params => post( BaseUrlNew + "/api/task/appeallist",params, headerDemo, 1, '1.0');
// 我的任务详情
export const postdetail = params => post( BaseUrlNew + "/api/task/mytask/detail",params, headerDemo, 1, '1.0');
// 更新任务状态
export const postprogress = params => post( BaseUrlNew + "/api/task/mytask/progress",params, headerDemo, 1, '1.0');


// ++++++++++ 账号管理 ++++++++++

// 【用户】新增
export const useradd = params => post( BaseUrlNew + "/api/user/add",params, headerDemo, 1, '1.0');
// 【用户】编辑
export const useredit = params => post( BaseUrlNew + "/api/user/edit",params, headerDemo, 1, '1.0');
// 【用户】查看详情
export const usergetinfo = (params, userId) =>get( BaseUrlNew + "/api/user/getinfo/"+userId,params, 1);
// 【用户】获取列表(分页)
export const usergetlist = params => post( BaseUrlNew + "/api/user/getlist",params, headerDemo, 1, '1.0');
// 【用户】禁用/启用
export const userchangestatus = params => post( BaseUrlNew + "/api/user/changestatus",params, headerDemo, 1, '1.0');
// 【用户】重置密码
export const userpwdreset = params => post( BaseUrlNew + "/api/user/pwd/reset",params, headerDemo, 1, '1.0');
// 【用户】设置角色
export const userroleset = params => post( BaseUrlNew + "/api/user/role/set",params, headerDemo, 1, '1.0');
// 【用户】获取角色集合
export const userrolegetlist = (params, userId) =>get( BaseUrlNew + "/api/user/role/getlist/"+userId,params, 1);


// ++++++++++ 角色管理 ++++++++++

// 【角色】获取列表(分页)
export const postrolelist = params => post( BaseUrlNew + "/api/role/getlist",params, headerDemo, 1, '1.0');
// 【角色】获取下拉列表
export const rolegetrolelist = params => get(BaseUrlNew + '/api/role/getrolelist', params, 1, '1.0');
// 【角色】获取详情
export const rolegetinfo = (params, roleId) =>get( BaseUrlNew + "/api/role/getinfo/"+roleId,params, 1);
// 【角色】获取列表(标识用户已设置角色)
export const rolegetlist = params => get(BaseUrlNew + '/api/role/getlist', params, 1, '1.0');
// 【角色】新增(自定义角色)
export const roleadd = params => post( BaseUrlNew + "/api/role/add",params, headerDemo, 1, '1.0');
// 【角色】编辑
export const roleedit = params => post( BaseUrlNew + "/api/role/edit",params, headerDemo, 1, '1.0');
// 【角色】禁用/启用
export const rolechangestatus = params => post( BaseUrlNew + "/api/role/changestatus",params, headerDemo, 1, '1.0');
// 【角色】设置菜单
export const rolemenuset = params => post( BaseUrlNew + "/api/role/menu/set",params, headerDemo, 1, '1.0');
// 【菜单】获取菜单列表(标识角色已设置菜单)
export const menugetvalidlist = params => post( BaseUrlNew + "/api/menu/getvalidlist",params, headerDemo, 1, '1.0');


// ++++++++++ 开放城市 ++++++++++

// 按层级获取省份城市列表
export const provincegetcitys = params => get(BaseUrlNew + '/api/area/province/getcitys', params, 1, '1.0');
// 开放城市
export const areaopencity = params => post( BaseUrlNew + "/api/area/opencity",params, headerDemo, 1, '1.0');


// ++++++++++ 客源定价 ++++++++++

// 获取客源线索售卖打底价
export const pricegetlist = params => get(BaseUrlNew + '/api/config/clue/price/getlist', params, 1, '1.0');
// 客源线索售卖打底价配置
export const priceset = params => post( BaseUrlNew + "/api/config/clue/price/set",params, headerDemo, 1, '1.0');

// 【通用】获取渠道分佣列表
export const orderGetlist = (params,channelType,businessId) =>post(
    BaseUrlNew + "/api/channel/order/getlist/" + channelType +'/'+ businessId,params, headerDemo, 1, '1.0');
    


// ++++++++++ 功能配置 ++++++++++

// 客源大厅退回保证金
export const vmtransactionrefund = params => post(BaseUrlNew + "/api/vmtransaction/refund", params, headerDemo, 1, '1.0');


// ++++++++++ 精准客户配置 ++++++++++
// 获取精准客户配置
export const getdetails = params => post(BaseUrlNew + "/api/precisioncustomer/config/getdetails", params, headerDemo, 1, '1.0');
// 保存精准客户配置
export const configsave = params => post(BaseUrlNew + "/api/precisioncustomer/config/save", params, headerDemo, 1, '1.0');



// WEBPACK FOOTER //
// ./src/api/comment.js